import { Checkbox } from '@doda/io-react/common';
import { ComponentProps } from 'react';
import classnames from 'classnames';
import styles from './index.module.scss';

/**
 * SearchCheckboxItemコンポーネントのプロパティ
 */
interface Props {
  /** チェックボックス項目のタイトル */
  title: string;
  /** チェックボックスの値 */
  value: ComponentProps<typeof Checkbox>['value'];
  /** チェックボックスに関連する件数 */
  count: number;
  /** チェックボックスの変更イベントハンドラ */
  onChange: ComponentProps<typeof Checkbox>['onChange'];
  /** チェックボックスが選択されているかどうかのフラグ */
  isChecked: boolean;
}

/**
 * 検索条件のチェックボックス項目を表示するコンポーネント
 *
 * @param {Props} props - SearchCheckboxItemのプロパティ
 * @returns {JSX.Element} 検索条件のチェックボックス項目のJSX要素
 */
export const SearchCheckboxItem: React.FC<Props> = ({
  title,
  value,
  count,
  onChange,
  isChecked,
}) => {
  return (
    <li className={styles.searchCondition__checkbox__wrapper}>
      <Checkbox
        onChange={onChange}
        value={value}
        checked={isChecked ?? false}
        label={
          <span
            className={classnames(styles.checkboxItem__title, {
              [styles['checkboxItem__title--checked']]: isChecked,
            })}
          >
            {title}
            <span className={styles.checkboxItem__count}>
              {`(${count?.toLocaleString() ?? 0})`}
            </span>
          </span>
        }
      />
    </li>
  );
};
